<template>
  <el-dialog :class="[currentTheme]" v-dialogDrag:{dialogDrag}=true title="家庭医生选择" :visible.sync="dialogVisible" width="1200px" height="600px" top="30px" :close-on-click-modal="false" @close='handleCloseDialog' append-to-body>
    <div class="main-box">
      <xr-table ref="teamUserTable" :configure="configure2"  ></xr-table>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: "teamUserSelect",
    computed: {
      currentTheme() {
        return this.$store.getters.themeType; //获取当前的主题类型
      },
    },
    data (){
      return {
        layoutConfigure:{
          northHeight: '300px',
          southHeight: '350px',
          isFixedSize: true,
        },
        dialogVisible: false,
        teamId: '',                                             //选中的id
        configure2: {
          url: '/web/service?method=tCoreMedicalTeamUser_list',
          listParam: {
            teamId: '-1'
          },
          isShowSearch: false,
          defaultNoLoadData: true,
          pagination: false,
          isSelectFirst: true,
          tableHeight: 600,
          idField: 'id',
          columns: [
            {
              field: 'radio',
              width: 60,
            },
            {
              field: 'userName',
              title: '姓名',
              width: 180,
              condition: {
                searchType: 'input',
                searchName: 'userNameSearch',
                value:''
              },
            },
            {
              field: 'adminType',
              title: '团队职务',
              width: 180,
              condition: {
                searchType: 'select',
                searchName: 'adminTypeSearch',
                value:'',
                selectList: [
                  {value: '1', label: '团队长'},
                  {value: '2', label: '团队成员'},
                  {value: '3', label: '指导专家'}
                ]
              },
            },
            {
              field: 'memberType',
              title: '人员分类',
              width: 180,
              condition: {
                searchType: 'select',
                searchName: 'memberTypeSearch',
                value:'',
                selectList: [
                  {value: '1', label: '临床医生(非中医)'},
                  {value: '2', label: '临床医生(中医/中西医)'},
                  {value: '3', label: '乡村医生'},
                  {value: '4', label: '公卫人员'},
                  {value: '5', label: '口腔医师'},
                  {value: '6', label: '药学人员'},
                  {value: '7', label: '影像人员'},
                  {value: '8', label: '护理人员'},
                  {value: '9', label: '其他'},
                  {value: '10', label: '其他'}
                ]
              },
            },
          ],
          toolbar: [
            {
              text: '确认',
              iconCls: 'wk wk-list2',
              that: this,
              handler: function () {
                this.that.getSelectedValue();
              }
            },
            {
              text: '取消',
              iconCls: 'wk wk-cancel2 wk-danger',
              that: this,
              handler: function () {
                this.that.handleCloseDialog();
              }
            },

          ]
        },
      }
    },
    components: {
    },
    methods: {
      init(teamId) {
         this.dialogVisible = true;
         this.teamId = teamId;
         this.configure2.listParam['teamId'] = teamId;
        this.$nextTick(()=> {
          this.$refs.teamUserTable.getData();
        })
      },
      //关闭窗口
      handleCloseDialog(){
        this.dialogVisible = false;
        this.$emit('cancelMethod');
      },
      //获取选中的值
      getSelectedValue(){
        let radio_value = this.$refs.teamUserTable.radio_value;

        let data = new Object();

        if(this.$refs.teamUserTable.radio_row){
          let clientInfo = this.$refs.teamUserTable.radio_row;
          if(!!clientInfo) {
            data.id = clientInfo.id;
            data.teamId = clientInfo.teamId;
            data.staffCode = clientInfo.staffCode;
            data.staffName = clientInfo.userName;
            data.adminType = clientInfo.adminType;
            data.adminTypeName = clientInfo.adminTypeName;
            data.workType = clientInfo.workType;
            data.workTypeName = clientInfo.workTypeName;
            data.memberType = clientInfo.memberType;
            data.memberTypeName = clientInfo.memberTypeName;
            data.orderNum = clientInfo.orderNum;
          }
        }
        if(!radio_value){
          this.$message({message: '请选择！',type: 'warning',duration: 1500})
          return false;
        }
        this.$emit('confirmMethod',data);
        this.dialogVisible = false;
      },


    }
  }
</script>





// WEBPACK FOOTER //
// src/components/PageSelect/ph/teamUserSelect.vue